import styled from "@emotion/styled";
import { Tooltip, tooltipClasses, TooltipProps } from "@mui/material";
import React from "react";

interface TooltipForTableProps {
  label: string;
  // When true, renders newline-separated values on their own lines in both the
  // tooltip and the cell (instead of single-line truncation with ellipsis).
  multiline?: boolean;
}
const CustomWidthTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 1000,
  },
});

const TooltipForTable = ({ label, multiline = false }: TooltipForTableProps) => {
  return (
    <CustomWidthTooltip
      title={
        multiline ? (
          <span style={{ whiteSpace: "pre-line" }}>{label || "-"}</span>
        ) : (
          label
        )
      }
      arrow
      placement="bottom-start"
    >
      <p
        className={`text-neutral-90 font-normal ${
          multiline ? "" : "common-text-ellipse-style"
        }`}
        style={multiline ? { whiteSpace: "pre-line" } : undefined}
      >
        {label || "-"}
      </p>
    </CustomWidthTooltip>
  );
};

export default TooltipForTable;
